import {useParams} from 'react-router-dom';
import {MRT_ColumnDef} from 'material-react-table';

import {useGetUserExtData, UserExtData} from '@entities/user';
import {MrTable} from '@shared/components';
import {DATETIME_FORMAT, entityTableCommonProps} from '@shared/constants';
import {formatInTz} from '@shared/utils';

const columns: MRT_ColumnDef<UserExtData>[] = [
  {accessorKey: 'name', header: 'Name', size: 180},
  {accessorKey: 'value', header: 'Value', size: 300},
  {
    accessorKey: 'created',
    header: 'Created',
    Cell: ({row}) => formatInTz(row.original.created, DATETIME_FORMAT),
    size: 180,
  },
];

export const UtmTab = () => {
  const {id: userId} = useParams<{id: string}>();
  const {data, isFetching, error} = useGetUserExtData(userId ?? '');

  return (
    <MrTable
      columns={columns}
      data={data ?? []}
      error={error}
      state={{isLoading: isFetching}}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
